export default __webpack_public_path__ + "static/media/ufo-wiener.dee73899.png";